import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchAddresses } from "redux/features/geocoding/geocodingThunk"

const geocodingAdapter = createEntityAdapter({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectId: (address: any) => address.geocoding_id,
})
export const initialState = geocodingAdapter.getInitialState({
  regioOptions: [],
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const geocodingSlice = createSlice({
  name: "geocoding",
  initialState,
  reducers: {
    resetRegioOptions: (state) => {
      state.regioOptions = []
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAddresses.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchAddresses.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(
        fetchAddresses.fulfilled,
        (state, { payload: { items, options } }) => {
          geocodingAdapter.setAll(state, items)
          state.regioOptions = options
          handleCollectionFetchFulfilled(state)
        },
      )
  },
})

export const selectRegioOptions = (state: RootState) =>
  state.features.geocoding.regioOptions

export const { selectAll: selectAllAddresses } = geocodingAdapter.getSelectors(
  (state: RootState) => state.features.geocoding,
)
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.geocoding.fetchCollectionStatus

export const { resetRegioOptions } = geocodingSlice.actions
export default geocodingSlice.reducer
